<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Change of Address (Foreign Company)
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="6">
          <Form26Resolution badge="Current Address" :data="getCompanyAddress ? getCompanyAddress.data : null"></Form26Resolution>
        </b-col>
        <b-col cols="6">
          <Form26Resolution badge="New Address" :data="data"></Form26Resolution>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Form26Resolution from "@/views/home/services/continuous-filing/task/forms/Form26Resolution.vue";
export default {
  name: "ChangeOfAddressForeign",
  components: { Form26Resolution},
  props:{
    data:Object,
    brn:String
  },
  mounted() {
    this.fetchCompanyAddress(this.brn)
  },
  methods:{
    ...mapActions(["fetchCompanyAddress"])
  },
  computed:{
    ...mapGetters(["getCompanyAddress"])
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}

.pdf{
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
}
</style>